/**
 * A library for media analysis using Web APIs.
 *
 * @packageDocumentation
 */
export * from './audio';
export * from './video';
export * from './visual';
export * from './types';
export * from './math';
export * from './process';
export * from './typeGuards';
export { createAsyncCallbackLoop, MediaStreamTrackTransferable } from './utils';
export * from './benchUtils';
export const urls = {
    denoise: () => new URL('../worklets/denoise.worklet.js', import.meta.url),
    mediaWorker: () => new URL('../workers/mediaWorker.js', import.meta.url),
};
export * from '../common/index';
//# sourceMappingURL=index.js.map